export function handleContextExampleEvent(notificationPayload) {
  window.dispatchEvent(
    new CustomEvent('sseContextExample', {
      detail: notificationPayload,
    }),
  );
}
